import React from 'react'
import PaperPage from 'src/components/organisms/whitepapers/PaperPage'
import thumbnail from 'src/images/whitepapers/commmune-airbnb_adopted.png'

const paperInfo = {
  paperName: 'Airbnbも取り入れているコミュニティマーケティングとは？',
  thumbnail,
  feature1: '海外の大企業がコミュニティを運営している理由',
  feature2: 'コミュニティマーケティングでできること',
  feature3: 'コミュニティマーケティングを取り入れるべき企業のチェックリスト',
  description:
    'これからは、企業とユーザーの双方向コミュニケーションや、個人が情報発信源となるユーザー同士の盛り上がりが大きな役割を担ってきます。BtoB、BtoC企業問わず注目を集めるコミュニティマーケティングについて解説します。',
  formSrc: 'https://go.commmune.jp/l/915341/2022-03-09/dxplr',
  type: 'pardot' // TODO: HubSpotからPardotに移行したらこのタグ付けが不要になるので削除する
}

const WhitePaperPage = () => {
  return <PaperPage {...paperInfo} />
}

export default WhitePaperPage
